export const valueByProp = (item: any, prop: string) => {
  let res = item;
  let field;

  try {
    let propPaths = prop.split(".");

    if (propPaths.length === 0) {
      propPaths = [prop];
    }

    while (propPaths.length > 0) {
      field = propPaths.shift();

      if (!field) {
        return;
      }

      if (Array.isArray(res[field])) {
        res = [];
        const deepProps = propPaths.splice(-1).join(".");

        for (let i = 0, ii = item[field].length; i < ii; i++) {
          res.push(valueByProp(item[field][i], deepProps));
        }
      } else {
        res = res[field];
      }
    }

    return res;
  } catch (e) {
    console.error("unexpected error occurred while trying to find value from pointer", item, prop);
    return;
  }
};
